module.exports = __webpack_public_path__ + "05_long_brown.56469333.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_long_brown.png
// module id = /L/v
// module chunks = 0